export default __webpack_public_path__ + "static/media/oxo_new_logo.ebeff98f.svg";